
function permissionToEdit(objects) {
    // const { permissions } = useAuthContext();
    const permissionsJson = localStorage.getItem('mico_permissions');

    if (permissionsJson) {
        const permissions = JSON.parse(permissionsJson);

        objects = objects.map(v => { return v.toLowerCase() })
        const res = permissions.filter(value => objects.some(v => value.toLowerCase().includes(v)))
        if (res.length > 0)
            return res[0].includes('write')
    }
    return false;

}

export default permissionToEdit;